// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__-rULS","input":"App_input__2tpv4"};